export function buildEliminarRegistroDominio(idDominio, uuidVenta) {
    return {
        idDominio: idDominio,
        uuidVenta: uuidVenta
    }
}

export function buildEliminarRegistroDominioResponse(responseEliminarRegistroDominio) {
    return {
        respuestaOK: responseEliminarRegistroDominio.respuestaOK,
        codigo: responseEliminarRegistroDominio.codigo,
        mensaje: responseEliminarRegistroDominio.mensaje
    }
}

export function buildObtenerPrecioProductoResponse(responseObtenerPrecioProducto) {
    const anios = Array.isArray(responseObtenerPrecioProducto.aniosContratacion)
        && responseObtenerPrecioProducto.aniosContratacion.length > 0
        ? responseObtenerPrecioProducto.aniosContratacion
        : [1];
    return {
        precioUnitario: responseObtenerPrecioProducto.precioUnitario,
        aniosContratacion: anios,
        codigo: responseObtenerPrecioProducto.codigoRespuesta,
        mensaje: responseObtenerPrecioProducto.mensajeRespuesta
    }
}